module.exports = __webpack_public_path__ + "static/media/evaluate.da2716ba.svg";